import { createSelector } from '@ngrx/store'

export const getLayersState = createSelector(
  (state: any) => state.layer,
  (state: any) => state.get('list'),
)

export const getCreateLayerState = createSelector(
  (state: any) => state.layer,
  (state: any) => state.get('createLayer'),
)

export const getUpdateLayerState = createSelector(
  (state: any) => state.layer,
  (state: any) => state.get('updateLayer'),
)
